import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import useAuth from './useAuth';
import { BASE_URL } from "./Constants";

const Upload_New = () => {
    const { id } = useParams();
     const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    emp_code: "",
    comp_name: "",
    designation_name: "",
    dept: "",
    band: "",
    questionData: [],
    ratingData: [],
    marks: "",
    overall_remarks: "",
    strengths: "",
    areas_of_improvement: "",
    training_needs: "",
    countscore: "",
    prepare_question: "",
    viva: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [EmpCode, setEmpCode] = useState('');
  const navigate = useNavigate();

  
  useAuth();

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}user_details?emp_code=${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
                  setUser(data);
                  setEmpCode(data.user.emp_code || '');
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    emp_code: data?.user?.emp_code || "",
                    comp_name: data?.user?.comp_name || "",
                    designation_name: data?.user?.designation_name || "",
                    dept_name: data?.user?.dept_name || "",
                    prepare_question: data?.user?.prepare_question || "",
                    viva: data?.user?.viva || "",
                  }));
        //const data = await response.json();

        if (!response.ok) {
          if (response.status === 401) {
            // If the token is expired or invalid, clear token and redirect to login
            localStorage.removeItem("authToken");
            navigate("/");
          }
          throw new Error(data.message || "Error fetching profile");
        }

        console.log("Profile data:", data);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, [navigate]);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

   
  };



//    useEffect(() => {
//       const fetchProfile = async () => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//           console.error("Auth token is missing");
//           navigate("/");
//           return;
//         }
  
//         try {
//           const response = await fetch(`${BASE_URL}profile`, {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           });
  
//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to fetch user profile");
//           }
  
//           const data = await response.json();
//           setUser(data);
//           setEmpCode(data.profile.emp_code || '');
//           setFormData((prevFormData) => ({
//             ...prevFormData,
//             emp_code: data?.profile?.emp_code || "",
//             comp_name: data?.profile?.comp_name || "",
//             designation_name: data?.profile?.designation_name || "",
//             dept_name: data?.profile?.dept_name || "",
//             prepare_question: data?.profile?.prepare_question || "",
//             viva: data?.profile?.viva || "",
//           }));
//         } catch (err) {
//           console.error("Error fetching profile:", err.message);
//           setError(err.message);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchProfile();
    
//     }, [navigate]);

    const handleChange = e => {
		const { name, value } = e.target;
		setFormData(prevState => ({
			...prevState,
			[name]: value, // Adjust to set value correctly
		}));
	};

  const handleSubmit = (e) => {
    e.preventDefault();
    

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("emp_code", formData.emp_code);
    formDataToSubmit.append("comp_name", formData.comp_name);
    formDataToSubmit.append("designation_name", formData.designation_name);
    formDataToSubmit.append("dept_name", formData.dept_name);
    formDataToSubmit.append("prepare_question", formData.prepare_question);
    formDataToSubmit.append("viva", formData.viva);

    formData.ratingData.forEach((item, index) => {
      formDataToSubmit.append(`ids[${index}]`, item.id);
      formDataToSubmit.append(`securedMarks[${index}]`, item.securedMarks);
    });

    fetch(`${BASE_URL}editEmployee/${EmpCode}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: formDataToSubmit,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "error") {
          alert(data.message || "An error occurred while submitting the data.");
        } else {
          alert("Data submitted successfully");
          navigate("/employee");
          // Refresh the page and then navigate to the Upload_New page
          window.location.reload();
          navigate("/employee"); // You can also add this line if you want to be sure the navigation happens
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        alert("An unexpected error occurred. Please try again.");
      });
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper" style={{ marginTop: "-55px" }}>
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-md-12 grid-margin">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h4 className="m-0">Employee Details</h4>
                  </div>
                </div>
              </div>
              <br />
              <div className="card" style={{ backgroundColor: "#f8f9fa", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", borderRadius: "10px" }}>
                <div className="card-body" style={{ padding: "20px" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label style={{ fontSize: "12px" }}><b>Emp Code</b></label>
                          <input type="text" name="emp_code" className="form-control input-font" value={formData.emp_code} onChange={handleInputChange} disabled/>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label style={{ fontSize: "12px" }}><b>Name</b></label>
                          <input type="text" name="emp_name" className="form-control input-font" value={formData.comp_name} readOnly disabled/>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label style={{ fontSize: "12px" }}><b>Designation</b></label>
                          <input type="text" name="designation" className="form-control input-font" value={formData.designation_name} readOnly disabled/>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label style={{ fontSize: "12px" }}><b>Department</b></label>
                          <input type="text" name="dept" className="form-control input-font" value={formData.dept_name} readOnly disabled/>
                        </div>
                      </div>
                      <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="prepare_question">prepare_question
                                                        <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <select required
                                                        name="prepare_question"
                                                        id="prepare_question"
                                                        value={formData.prepare_question}
                                                        onChange={handleChange}
                                                        className="form-control "
                                                    >
                                                        <option value="">Select</option>
                                                        <option value='Y'>Yes</option>
                                                        <option value='N'>No</option>

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="viva">viva
                                                        <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <select required
                                                        name="viva"
                                                        id="viva"
                                                        value={formData.viva}
                                                        onChange={handleChange}
                                                        className="form-control "
                                                    >
                                                        <option value="">Select</option>
                                                        <option value='Y'>Yes</option>
                                                        <option value='N'>No</option>

                                                    </select>
                                                </div>
                                            </div>
                                            
                    </div>

                    
                    <button type="submit" className="btn btn-primary"
                              style={{ backgroundColor: "#007bff", border: "none", color: "white", padding: "10px 20px", borderRadius: "5px", cursor: "pointer" }}>Submit</button>
                  </form>
                  {loading && <p>Loading...</p>}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              </div>
            </div>
          </div>
          <footer className="footer">
            <span className="text-muted">© {new Date().getFullYear()} Vijaya Diagnostic Centre</span>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Upload_New;
